// Modules
import React from "react";
// @ts-ignore
import { LocalizationContext } from 'react-localize';

// Interfaces
import {DailyAvailability} from "Interfaces/ResortResultInterface";
import {RoomModal, RoomInformation} from "Interfaces/RoomModalInterface";

// Components
import MvModal from "Generic/MvModal";
import MvLoader from "Generic/MvLoader/MvLoader"

// Styles
import "./MvRoomModal.sass"

interface Props {
  data: any;
  toggle(): void;
  fetchLoaded:boolean
 
};

class MvRoomModal extends React.Component<Props, {}> {

  render() {
    
    const { localize } = this.context;
    const {data, toggle} = this.props;

    const {show, room} = data;

    const {
      roomName,
      bedrooms,
      sleepCapacity,
      floorplanImg,
    }: RoomInformation = room;

    return (
      <div className={`mv-resort-modal ${show ? 'show' : ''}`}>

      <MvModal openModal={show} toggleModal={toggle}>
        <MvLoader show={!this.props.fetchLoaded} >
          <div className={"modal-container " + ((data.floorplanimage && data.floorplanimage.length > 0) ? "has-floor-plan" : "")}>
            <div className='modal-header'>{data.description}</div>
              {(data.floorplanimage && data.floorplanimage.length > 0) &&
                <div className="modal-floor-plan">
                  <img className='fl-plan-img' src={data.floorplanimage} />
                </div>
              }          
            <div className='desc-content'>
              <span dangerouslySetInnerHTML={{ __html:  data.roomTypeDescription }}></span>
              <span dangerouslySetInnerHTML={{ __html:  data.bedDescription }}></span>
              <span>{localize("static.content.sleep-capacity")} {data.sleepcapacity}</span>
            </div>
          </div>
        </MvLoader>
      </MvModal>
      </div>  
    );
  }
};

MvRoomModal.contextType = LocalizationContext;
export {
  MvRoomModal,
};
